import React from "react";

const common = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

const paths = {
  bolt: (
    <>
      <path d="M13 2 4 14h7l-1 8 9-12h-7l1-8z" />
    </>
  ),
  document: (
    <>
      <path d="M8 3h6l4 4v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" />
      <path d="M14 3v5h4" />
      <path d="M9 13h6" />
      <path d="M9 17h4" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="8" />
      <path d="M12 8v5l3 2" />
    </>
  ),
  tag: (
    <>
      <path d="M3 12V5a2 2 0 0 1 2-2h7l9 9-9 9-9-9z" />
      <circle cx="7.5" cy="7.5" r="1" />
    </>
  ),
  bell: (
    <>
      <path d="M15 17H9" />
      <path d="M18 16v-5a6 6 0 10-12 0v5" />
      <path d="M6 16l-1.5 1.5" />
      <path d="M18 16l1.5 1.5" />
      <path d="M10 19a2 2 0 004 0" />
    </>
  ),
  bookmark: (
    <>
      <path d="M7 4h10a1 1 0 0 1 1 1v16l-6-3.5L6 21V5a1 1 0 0 1 1-1z" />
    </>
  ),
  gauge: (
    <>
      <path d="M5 19a9 9 0 1 1 14 0" />
      <path d="M12 13l4-4" />
      <circle cx="12" cy="13" r="1.2" fill="currentColor" stroke="none" />
    </>
  ),
  filter: (
    <>
      <path d="M4 5h16l-6 7v6l-4 2v-8L4 5z" />
    </>
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="6" />
      <path d="M16 16l4 4" />
    </>
  ),
  chart: (
    <>
      <path d="M4 19V5" />
      <path d="M4 19h16" />
      <path d="M8 15l3-4 3 2 4-6" />
    </>
  ),
  bot: (
    <>
      <rect x="5" y="8" width="14" height="11" rx="3" />
      <path d="M12 8V5" />
      <circle cx="9" cy="13" r="1" fill="currentColor" stroke="none" />
      <circle cx="15" cy="13" r="1" fill="currentColor" stroke="none" />
      <path d="M9 17h6" />
    </>
  ),
  builder: (
    <>
      <path d="M7 7h10" />
      <path d="M7 17h10" />
      <path d="M10 7v10" />
      <path d="M14 7v10" />
      <path d="M9 12h6" />
    </>
  ),
  discovery: (
    <>
      <circle cx="11" cy="11" r="6.5" />
      <path d="M16 16l4.5 4.5" />
      <path d="M11 8v6" />
      <path d="M8 11h6" />
    </>
  ),
};

export default function ProductIcon({ name, className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true" {...common}>
      {paths[name] || null}
    </svg>
  );
}

export function AppleMark({ className = "h-4 w-4" }) {
  return (
    <svg viewBox="0 0 384 512" aria-hidden="true" className={className} fill="currentColor">
      <path d="M318.7 268.6c-.3-49.2 40.4-72.8 42.2-74-23-33.6-58.7-38.2-71.3-38.7-30.4-3.1-59.3 17.9-74.7 17.9-15.4 0-39.2-17.4-64.5-16.9-33.1 .5-63.6 19.2-80.5 48.8-34.4 59.6-8.8 147.8 24.7 196.2 16.4 23.7 36 50.3 61.7 49.3 24.8-1 34.2-16 64.1-16 29.8 0 38.3 16 64.6 15.5 26.7-.5 43.6-24.2 59.9-48 18.9-27.6 26.7-54.3 27-55.7-.6-.3-51.7-19.9-52-78.7zM265.1 114.1c13.7-16.6 22.9-39.7 20.4-62.8-19.7 .8-43.6 13.1-57.8 29.7-12.7 14.7-23.8 38.3-20.8 60.9 22.1 1.7 44.5-11.2 58.2-27.8z" />
    </svg>
  );
}
